// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#d8dadb","menuText":"#3b3b3b","menuActiveText":"#3b3b3b"};